export default () => {
  // TODO: fill in these values
  return {
    osContext: {},
    clientContext: {},
  };
};
